import { skipTokens } from '@jet-pie/theme/variations/skip';

export const colors = {
    ...skipTokens.global,
    alias: skipTokens.alias.light
};
